import { BaseModel } from './baseModel';
import Color from 'colorjs.io';

/**
 * Excel built-in colors
 */
export const INDEXED_COLORS: Color[] = [
  new Color('#000000'),
  new Color('#FFFFFF'),
  new Color('#FF0000'),
  new Color('#00FF00'),
  new Color('#0000FF'),
  new Color('#FFFF00'),
  new Color('#FF00FF'),
  new Color('#00FFFF'),
  new Color('#800000'),
  new Color('#008000'),
  new Color('#000080'),
  new Color('#808000'),
  new Color('#800080'),
  new Color('#008080'),
  new Color('#C0C0C0'),
  new Color('#808080'),
  new Color('#9999FF'),
  new Color('#993366'),
  new Color('#FFFFCC'),
  new Color('#CCFFFF'),
  new Color('#660066'),
  new Color('#FF8080'),
  new Color('#0066CC'),
  new Color('#CCCCFF'),
  new Color('#000080'),
  new Color('#FF00FF'),
  new Color('#FFFF00'),
  new Color('#00FFFF'),
  new Color('#800080'),
  new Color('#800000'),
  new Color('#008080'),
  new Color('#0000FF'),
  new Color('#00CCFF'),
  new Color('#CCFFFF'),
  new Color('#CCFFCC'),
  new Color('#FFFF99'),
  new Color('#99CCFF'),
  new Color('#FF99CC'),
  new Color('#CC99FF'),
  new Color('#FFCC99'),
  new Color('#3366FF'),
  new Color('#33CCCC'),
  new Color('#99CC00'),
  new Color('#FFCC00'),
  new Color('#FF9900'),
  new Color('#FF6600'),
  new Color('#666699'),
  new Color('#969696'),
  new Color('#003366'),
  new Color('#339966'),
  new Color('#003300'),
  new Color('#333300'),
  new Color('#993300'),
  new Color('#993366'),
  new Color('#333399'),
  new Color('#333333'),
];

export class ColorScheme extends BaseModel {
  // Default ONLYOFFICE colors
  public dk1 = new Color('#000000');
  public lt1 = new Color('#FFFFFF');
  public dk2 = new Color('#44546A');
  public lt2 = new Color('#E7E6E6');
  public accent1 = new Color('#5B9BD5');
  public accent2 = new Color('#ED7D31');
  public accent3 = new Color('#A5A5A5');
  public accent4 = new Color('#FFC000');
  public accent5 = new Color('#4472C4');
  public accent6 = new Color('#70AD47');
  public hlink = new Color('#0563C1');
  public folHlink = new Color('#954F72');
}

export type ColorSchemeName =
  | 'dk1'
  | 'lt1'
  | 'dk2'
  | 'lt2'
  | 'accent1'
  | 'accent2'
  | 'accent3'
  | 'accent4'
  | 'accent5'
  | 'accent6'
  | 'hlink'
  | 'folHlink';

export class WorkbookStyle extends BaseModel {
  public colorScheme = new ColorScheme();
  // TODO: public fontScheme
  // TODO: public formatScheme
}
